import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, FieldArray, reduxForm, change } from 'redux-form';
import Typography from '@material-ui/core/Typography';

import DatepickerField from 'components/fields/DatepickerField';
import AutosuggestField from 'components/fields/AutosuggestField';
import FiltersFieldArray from 'components/fields/FiltersFieldArray';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import pxToRem from 'styles/pxToRem';

import dateFormat from 'config/dateFormat';

const styles = theme => ({
  label: {
    paddingTop: 7,
    fontSize: pxToRem(12),
    fontWeight: '700',
    color: theme.palette.grey[600],
  },
  grid: {
    marginTop: 10,
  },
});

function onChange(values, dispatch, props, prevValues) {
  if (values['Selected Sign Order']) {
    if (!values['Sign Order']
      || values['Sign Order'].findIndex(item =>
        item.value === values['Selected Sign Order'].value) === -1) {
      props.array.push('Sign Order', values['Selected Sign Order']);
    }
    props.clearFields(false, false, 'Selected Sign Order');
  }
}

const DocumentsSignDialogForm = props => {
  const remainingSignOrders = props.initialValues && props.initialValues['Sign Order']
    && props.formValues && props.formValues['Sign Order']
    ? props.initialValues['Sign Order'].filter(initialItem => !props.formValues['Sign Order']
      .find(item => item.value === initialItem.value))
    : [];
  return (
    <form
      noValidate
      autoComplete="off"
      onSubmit={props.handleSubmit}
      className={props.className}
    >
      <Grid
        container
        justify="flex-start"
        alignItems="flex-end"
        spacing={24}
      >
        <Grid
          item
          xs={6}
          md={4}
        >
          <Field
            id="Date of Delivery"
            name="Date of Delivery"
            label="Date of Delivery"
            component={DatepickerField}
            validate={[validate.date]}
            normalize={normalize.date}
            fullWidth
            minDate="01/01/1900"
            maxDate={moment().format(dateFormat)}
            dateFormat={dateFormat}
            placeholder="Date of Delivery"
            endIcon="start"
            errorPlacement="bottom"
            datepickerPlacement="bottom-left"
          />
        </Grid>
        {props.initialValues && props.initialValues['Sign Order']
          && props.initialValues && props.initialValues['Sign Order'].length > 0 &&
          <Grid item xs={4}>
            <Field
              name="Sign Order ID"
              autosuggestFieldName="Sign Order ID"
              fieldArrayName="Sign Order"
              placeholder="-Add Orders to Sign-"
              component={AutosuggestField}
              renderSuggestionContent={suggestion => suggestion.label}
              renderInputContent={suggestion => suggestion.label}
              onSuggestionSelected={(suggestion) => {
                props.change('Selected Sign Order', {
                  value: suggestion.value,
                  label: suggestion.label,
                });
                return '';
              }}
              fetchSuggestions={({ value, offset }) => (new Promise((resolve) => {
                if (offset === 0) {
                  if (value.length > 0) {
                    resolve(remainingSignOrders
                      .filter(item => item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1));
                  } else {
                    resolve(remainingSignOrders);
                  }
                } else {
                  resolve([]);
                }
              }))}
              keepOpenAfterSelection
              disabled={remainingSignOrders.length === 0}
            />
          </Grid>
        }
      </Grid>
      {(props.formValues && props.formValues['Sign Order'] && props.formValues['Sign Order'].length > 0) &&
        <Grid
          className={props.classes.grid}
          container
          justify="flex-start"
          spacing={8}
        >
          <Grid item>
            <Typography className={props.classes.label}>
              Orders to Sign:
            </Typography>
          </Grid>
          <Grid item>
            <FieldArray
              id="Sign Order"
              name="Sign Order"
              component={FiltersFieldArray}
              size="sm"
            />
          </Grid>
        </Grid>
      }
    </form>
  );
};

DocumentsSignDialogForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
};

DocumentsSignDialogForm.defaultProps = {
  className: '',
};

export default reduxForm({ onChange })(withStyles(styles)(DocumentsSignDialogForm));



// WEBPACK FOOTER //
// ./src/components/common/DocumentsSignDialog/DocumentsSignDialogForm.js